import React from "react";
import TagManager from 'react-gtm-module';
import { Typography, ListItem, ListItemText, Tooltip } from "@material-ui/core/";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
//css
import PendenciasCss from "./pendencias-css";
const useStyles = PendenciasCss();

export default function ComunicadosHome(props) {
    const classes = useStyles();
    function StringToDateFormater(dateStr) {
        const date = dateStr.split(" ");
        // const dateObject = moment(date[0], "DD/MM/YYYY");
        return date[0];
    }

    return (
        <>
            {props.state.itens.length === 0 && (
                <Typography variant="body1" component="p" align={"center"}>
                    Nenhuma {props.props.message}!
                </Typography>
            )}
            {props.state.itens.length !== 0 && (
                <ListItem>
                    <Typography variant="body1" className={classes.titlePendencias}>
                        {"Confirmação de agendamento"}
                    </Typography>
                </ListItem>
            )}
            {props.state.itens.map((item, index) => (
                <ListItem alignItems={"flex-start"} disablegutters={"true"} key={index} button>
                    <ListItemText
                        primary={
                            <React.Fragment>
                                <Tooltip
                                    disableFocusListener
                                    followCursor={true}
                                    title={item.QT_DIAS_PRAZO === "0" ? `Prazo Expirado ${StringToDateFormater(item.DT_AGENDA)}` : `Irá expirar dia ${StringToDateFormater(item.DT_AGENDA)}` }
                                >
                                    <Typography
                                        component="span"
                                        variant="body2"
                                        className={classes.inline + " " + classes.data}
                                        color="textPrimary"
                                        style={{ color: "red" }}
                                    >
                                        {item.QT_DIAS_PRAZO === "0" ? `Prazo Expirado dia ${StringToDateFormater(item.DT_AGENDA)}` : `Irá expirar em ${item.QT_DIAS_PRAZO} dias!`}
                                    </Typography>
                                </Tooltip>
                                {item.QT_DIAS_PRAZO === "0" && (
                                    <Tooltip
                                        disableFocusListener
                                        title={"Prazo Expirado"}
                                        placement="center"
                                    >
                                        <i
                                            style={{
                                                fontSize: "15px",
                                                float: "right",
                                                color: "#deac1e",
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faExclamationTriangle} />
                                        </i>
                                    </Tooltip>
                                )}
                            </React.Fragment>
                        }
                        secondary={
                            <React.Fragment>
                                <Typography
                                    component="span"
                                    variant="body2"
                                    className={classes.inline}
                                    color="textPrimary"
                                    style={
                                        props.state.listaNovo.includes(item.NR_PC)
                                            ? { fontWeight: "bold" }
                                            : null
                                    }
                                >
                                    {`Nº Pedido: `}
                                </Typography>
                                {item.NR_PC}
                            </React.Fragment>
                        }
                        onClick={() => {
                            props.props.pai.props.router.push(`GerenciarPedidos/tab/1`);

                            TagManager.dataLayer({
                                dataLayer: {
                                  event: 'event',
                                  eventCategory: 'tokstok:fornecedores:inicio',
                                  eventAction: 'clique:pendencias',
                                  eventLabel: `pedido-${item.NR_PC}`,
                                }
                            });
                        }}
                    />
                </ListItem>
            ))}
        </>
    );
}
